module.exports = "/images/dots.svg?a5e830d5115b885915d111dc8643f97f";